import Item from 'common/ITEMS/Item';

const items = {
  //region Arcane
  //endregion
  //region Fire
  //endregion
  //region Frost
  //endregion
  //region Shared
  //endregion
} satisfies Record<string, Item>;
export default items;
